export enum SearchEventTypes {
  UpcomingEvents = "upcomingEvents",
  PastEvents = "pastEvents",
}